<script>
// import axios from "axios";

import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/preloader";
import { mapGetters, mapActions } from "vuex";
import Swal from "sweetalert2";
import moment from "moment";
import axios from 'axios';
/**
 * Advanced table component
 */
export default {
  page: {
    title: "Account Transactions",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Layout,
    PageHeader,
    Loader,
  },
  data() {
    return {
      title: "Account Transactions",
      items: [
        {
          text: "Home",
          href: "#/",
        },
        {
          text: "Account Transactions",
          active: true,
        },
      ],
      totalRows: 1,

      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100, 200, 1000],
      filter: null,
      todoFilter: null,
      filterOn: [],
      todofilterOn: [],
      sortDesc: false,
      fields: [
        {
          key: "index",
          sortable: true,
          label: "S/N",
        },
        {
          key: "date",
          sortable: true,
          label: "DATE",
        },
        {
          key: "reference",
          sortable: true,
          label: "REFERENCE",
        },        
        {
          key: "dr",
          sortable: true,
          label: "DEBIT AMOUNT",
        },
        {
          key: "cr",
          sortable: true,
          label: "CREDIT AMOUNT",
        },
        {
          key: "balance",
          sortable: true,
          label: "BALANCE",
        }
      ],
      filterTransactions:{
        datefrom: '',
        dateto: moment(new Date()).format("YYYY-MM-DD"),
        id: atob(this.$route.params.id),
      },
      total_credit:0,
      total_debit:0,

      creditError: "",
      debitError: "",
      amountError: "",
      TypeError:"",      
    };
  },
  computed: {
    ...mapGetters("setting", ["filterStatus","Statement"]),

    /**
     * Total no. of records
     */

    rows() {
      return this.Statement ? this.Statement.length : 1;
    },

    /**
     * Todo list of records
     */
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.Statement ? this.Statement.length : 1;
  },
  updated(){
    let total_credit = 0;
    let total_debit = 0;
      // let total_paid = 0;
      if(this.Statement){
        this.Statement.forEach((item)=>{
          total_credit = total_credit+parseInt(item.cr);
          total_debit = total_debit+parseInt(item.dr);
        });
        this.total_debit = total_debit;
        this.total_credit = total_credit;
      }
  },
  watch: {
    show(newValue) {
      // Do whatever makes sense now
      if (newValue == true) {
        if (this.type == "success") {
          this.closeModal(this.modal_id);
          Swal.fire("Success!", this.message.msg, "success");
          // this.$toast.success(this.message.msg);
        } else {
          // this.$toast.error(this.message.msg);
          Swal.fire("Error!", this.message.msg, "error");
        }
      }
    },
  },
  methods: {
    ...mapActions({
      FetchTransactions: "setting/fetchStatement",
    }),
    /**
     * Search the table data with search input
     */
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    // COMMA SEPERATORS
    thousandSeperator(m) {
      if (m !== "" || m !== undefined || m !== 0 || m !== "0" || m !== null) {
        return m
            .toString()
            .replace(/\D/g, "")
            .replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      } else {
        return m;
      }
    },
    FetchStatement() {
      this.FetchTransactions(this.filterTransactions);
    },
    Excel_export() {
      axios
        .post("export_statement", this.filterTransactions,{
          responseType: "arraybuffer",
        })
        .then((response) => {
          var fileURL = window.URL.createObjectURL(new Blob([response.data]));
          var fileLink = document.createElement("a");
          fileLink.href = fileURL;
          fileLink.setAttribute("download", "transaction_statement.xlsx");
          document.body.appendChild(fileLink);
          fileLink.click();
          this.spinner = false;
        })
        .catch(() => {
        });
    },
  },
  created() {
    this.FetchTransactions(this.filterTransactions);
  },
};
</script>

<template>
  <Layout>
    <Toasts
      :show-progress="true"
      :rtl="true"
      :max-messages="20"
      :time-out="3000"
      :closeable="false"
      :solid="true"
    ></Toasts>
    <PageHeader :title="title" :items="items" />

    <div class="row">      
      <div class="col-12">
        <div class="text-center text-bold">
          <h4>TRANSACTIONS FOR ACCOUNT {{ Statement?Statement[0].accounts.name:'' }}</h4>
        </div>
        <div class="card">
          <div class="row mt-2">
            <div class="col-10"></div>
            <div class="col-2">
              <b-button variant="info" @click="Excel_export()"
                ><i class="fa fa-download"></i> Export</b-button>
            </div>
          </div>
          <div class="row mt-2 px-2">
            <div class="col-md-4 form-group">
              <label>FROM</label>
              <input
                type="date"
                v-model="filterTransactions.datefrom"
                class="form-control"
              />
            </div>
            <div class="col-md-4 form-group">
              <label>TO</label>
              <input
                v-model="filterTransactions.dateto"
                type="date"
                class="form-control"
              />
            </div>
            <div class="col-md-2 mt-4">
            <button class="btn btn-primary" type="button" @click="FetchStatement()">
              <span class="fa fa-filter"></span> Filter
              <b-spinner
                v-show="filterStatus"
                variant="light"
                small
                role="status"
              ></b-spinner>
            </button>
          </div>
              <div class="col-md-2 mt-4" align="right">
                <b-button @click="$router.go(-1)" variant="warning"><i class="fa fa-undo"></i> Back</b-button>
              </div>          
          </div>
          <div class="card-body">
            <div class="row mt-4">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show&nbsp;
                    <b-form-select
                      class="form-select form-select-sm"
                      v-model="perPage"
                      size="sm"
                      :options="pageOptions"
                    ></b-form-select
                    >&nbsp;entries
                  </label>
                </div>
              </div>
              <!-- Search -->
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end">
                  <label class="d-inline-flex align-items-center">
                    Search:
                    <b-form-input
                      v-model="filter"
                      type="search"
                      placeholder="Search..."
                      class="form-control form-control-sm ms-2"
                    ></b-form-input>
                  </label>
                </div>
              </div>
              <!-- End search -->
            </div>
            <!-- Table -->
            <div class="table-responsive mb-0">
              <b-table
                class="datatables"
                :items="Statement ? Statement : []"
                :fields="fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :sort-desc.sync="sortDesc"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="onFiltered"
              >
                <template #cell(index)="data">
                  {{ data.index + 1 }}
                </template>
                <template #cell(dr)="data">
                  {{ (data.item.dr).toLocaleString() }}
                </template>
                <template #cell(cr)="data">
                  {{ (data.item.cr).toLocaleString() }}
                </template>
              </b-table>
              <div class="row">
                  <div class="col-md-4">
                    <h5>Total Debit: <span class="text-primary">{{(total_debit).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Credit: <span class="text-danger">{{(total_credit).toLocaleString()}}</span></h5>
                  </div>
                  <div class="col-md-4">
                    <h5>Total Balance: <span class="text-danger" v-if="total_debit-total_credit<0">{{(total_debit-total_credit).toLocaleString()}}</span>
                      <span class="text-success" v-else>{{(total_debit-total_credit).toLocaleString()}}</span></h5>
                  </div>
                </div>
            </div>
            <Loader v-if="!Statement"/>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <!-- pagination -->
                    <b-pagination
                      v-model="currentPage"
                      :total-rows="rows"
                      :per-page="perPage"
                    ></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
            <!-- modal ends -->
          </div>
        </div>
      </div>
    </div>
  </Layout>
</template>
<style>
.btn-primary,.page-link { background-color:#FAB031 !important;border-color:#FAB031 !important;}
</style>   
